
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IBenefits, IBenefitsItems, INavigationItem } from '@share/common-types';
import { Routes, Urls } from '@share/constants';
import { axiosInstance } from '@share/utils';
import { AppThunk } from '@share/utils';
import { get, isEmpty } from 'lodash';
import { setMenu } from './menu';

export interface IBenefitsState {
  benefits: IBenefits | null;
  loading: boolean;
  error: string;
}

const initialState: IBenefitsState = {
  benefits: null,
  loading: false,
  error: '',
};

const benefitsSlice = createSlice({
  name: 'benefits',
  initialState,
  reducers: {
    setLoading: (state: IBenefitsState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setError: (state: IBenefitsState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setBenefits: (state: IBenefitsState, { payload }: PayloadAction<IBenefits | null>) => {
      state.benefits = payload;
    },
  },
});

export const benefitsActions = benefitsSlice.actions;

export const benefitsReducer = benefitsSlice.reducer;

const CRUISES_TITLE = 'Cruises';

export const getBenefits = (keyId: number): AppThunk => {
  return async (dispatch, getState) => {
    dispatch(benefitsActions.setLoading(true));

    try {
      const { loginStore, navigationMenuStore } = getState();
      const { account } = loginStore;
      const { items } = navigationMenuStore;

      const res = await axiosInstance.get(`${Urls.Benefits}/${keyId}`);

      let benefits = res.data ? { ...res.data } : null;

      const benefitItems = benefits?.items;
      const condoItem = benefitItems?.find((item: any) => item.title === 'Condos');
      const condoItemsFiltered = benefitItems?.filter((item: any) => item.title !== 'Condos');
      const condoItemChildItems = condoItem?.childItems;
      const weeklySpecialHash = account?.weeklySpecialHash;
      const isCustomerAgent = account?.isCustomerAgent;
      const isWeeklySpecialHash = account?.weeklySpecialHashEnabled && 
                                      ((!account?.weeklySpecialHashRsiSiteidList?.length && !account?.weeklySpecialHashRsiOrgidList?.length) || 
                                       (account?.weeklySpecialHashRsiSiteidList?.includes(items?.siteId?.toString()) || account?.weeklySpecialHashRsiOrgidList?.includes(items?.organizationId?.toString())));
      if (weeklySpecialHash &&
          weeklySpecialHash?.value &&
          !isEmpty(weeklySpecialHash?.value) &&
          isWeeklySpecialHash && 
          benefits &&
          condoItemChildItems?.length) {

        
        benefits = {
          items: [
            {
              ...condoItem,
              childItems: [
                ...condoItemChildItems,
                {
                  title: "Weekly Condo Specials - A short listing of unbeatable prices",
                  imageUrl: "https://rsistaticdata.s3.amazonaws.com/benefits/condo-specials.jpg",
                  description: "Typically 100+ condo specials selected especially for our members. They are first come, first-served and they go fast. So don't delay and call today.",
                  url: `${Routes.CondosWeeklySpecials}`,//?queryHash=${weeklySpecialHash?.value}`,
                  type: "condos"
                },
              ],
            },
            ...condoItemsFiltered,
          ],
        }
      }

      const benefitsCruises = benefits?.items?.find((item: IBenefitsItems) => item.type === 'cruises');
      const cruisesFiltered = benefitsCruises?.childItems?.filter((cruise: any) => cruise.title === 'Luxury Cruises');
      const { url } = get(cruisesFiltered, '[0]', {} as IBenefitsItems);
    
      if (url && !isEmpty(url) && items?.main?.length && isCustomerAgent) {
        const hasCruiceMenuItem = items?.main?.some((item: INavigationItem) => item.title === CRUISES_TITLE);
        if (hasCruiceMenuItem) {
          const main = items?.main?.map((m: INavigationItem) => m.title === CRUISES_TITLE ? { ...m, url } : m);
          dispatch(setMenu({ ...items, main }));
        }
      }


      dispatch(benefitsActions.setLoading(false));
      dispatch(benefitsActions.setBenefits(benefits));
    } catch (error: any) {
      console.error(error);
      dispatch(benefitsActions.setError(error.toString()));
      dispatch(benefitsActions.setLoading(false));
    }
  };
};
